<ng-template #previewWindow let-data>
  <div class="doc-header">
    <div class="actions">
      <img alt="close" [src]="'images/close_grey.svg' | assetUrl" class="white-icon cursor-pointer"
        draggable="false" mat-dialog-close>
      </div>
      <div class="fileName">{{data.name}}</div>
      <div>
        @if (this.showLoader) {
          <mat-spinner diameter="24" mode="indeterminate" strokeWidth="2" value="100"
          class="overlay-spinner-preview"></mat-spinner>
        }
        @else {
        @if (data.kind !== 'note' && !isMobileScreen) {
          <img alt="download" [src]="'images/download.svg' | assetUrl" class="white-icon cursor-pointer"
            [matTooltip]="'Download File'" draggable="false"
            (click)="downloadFile()" (keypress)="downloadFile()">
        }
      }

    </div>
  </div>
  <mat-dialog-content>
    @if (!isMobileScreen) {
      <div class="info-msg">
        **For better experience, please download the file!
      </div>
    }

    @if (data.fileExtension.includes('doc') && !isMobileScreen) {
      <div class="red-lines">
        **In preview mode, you won’t see the <span>RedLines</span>. Please download the document to see the
        <span>RedLines</span>.
      </div>
    }
    <!-- @if (data.kind === 'note') {
    <div [innerHTML]="data?.content"></div>
  }
  @else {
  <collaboration-ui-pdf-renderer
    [src]="data.pdfBytes"
    [fileName]="data.name"
    [isMobileScreen]="isMobileScreen">
  </collaboration-ui-pdf-renderer>
  } -->

  @if(data.fileExtension === 'msg') {
    <pre [innerHTML]="data?.emailContent?.body" class="email-content"></pre>
  }
  @else if(data.fileExtension === 'csv') {
  <pre class="email-content">{{data.csvData}}</pre>
}
@else if (data.kind === 'note') {
<div [innerHTML]="data?.content"></div>
}
@else if (data.kind === 'image') {
<div class="image-viewer">
  <img alt="view" [src]="data.blobUrl" style="max-width:100%;height:auto;">
</div>
}
@else {
@if(isMobileScreen) {
  <div #pdfContainer></div>
}
@else {
<iframe title="preview" [src]="data.blobUrl" width="100%" height="100%"
style="background-color: white;"></iframe>
}
}

</mat-dialog-content>
<!-- <mat-dialog-actions [align]="'end'">
<button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions> -->
</ng-template>